var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/index.ts
import Cookie from "js-cookie";
import { v4 as uuidv4 } from "uuid";

// src/focus.ts
var focused = void 0;
var blurCallback = void 0;
var focusCallback = void 0;
window.addEventListener("blur", () => {
  if (focused !== false) {
    focused = false;
    if (blurCallback) {
      blurCallback();
    }
  }
});
window.addEventListener("focus", () => {
  if (focused !== true) {
    focused = true;
  }
  if (focusCallback) {
    focusCallback();
  }
});
var focus = {
  onBlur: (cb) => {
    blurCallback = cb;
  },
  onFocus: (cb) => {
    focusCallback = cb;
  }
};

// src/index.ts
var SESSION_LENGTH = 30;
var SID_COOKIE_NAME = "ois";
var SESSION_LENGTH_MS = SESSION_LENGTH * 60 * 1e3;
var FORBIDDEN_EVENTS = ["firstVisit", "sessionStart", "engagement", "pageEngagement"];
var PAGE_VIEW_EVENT_NAME = "pageView";
var collector = "";
var consenting = false;
var enrichers = [];
var initiated = false;
var memoryCookie = void 0;
var pageViewCount = 0;
var pageViewData = void 0;
var reloads;
var uid = "";
var persistSession = (session) => {
  const now = new Date();
  session.z = now.getTime();
  const sessionJson = JSON.stringify(session);
  const expires = new Date(now.setMinutes(now.getMinutes() + SESSION_LENGTH));
  if (consenting) {
    Cookie.set(SID_COOKIE_NAME, sessionJson, { expires });
  } else {
    memoryCookie = sessionJson;
  }
  return session;
};
var getSession = () => {
  const sessionJson = memoryCookie || Cookie.get(SID_COOKIE_NAME);
  let session = sessionJson && JSON.parse(sessionJson);
  const now = new Date().getTime();
  const sessionLength = !(session == null ? void 0 : session.z) ? 0 : now - session.z;
  if (session && sessionLength < SESSION_LENGTH_MS) {
    session.seq++;
    if (!reloads) {
      reloads = session.reload + 1;
      session.reload++;
    }
    session.ts = session.ts || now;
    return persistSession(session);
  }
  reloads = 1;
  session = {
    eng: false,
    id: uuidv4(),
    ref: document.referrer,
    reload: 1,
    seq: 1,
    ts: now
  };
  const persisted = persistSession(session);
  sessionStart();
  return persisted;
};
var getQueryParams = (url) => {
  const parts = url.split("?");
  const search = parts.length <= 1 ? parts[0] : parts[1];
  if (!search) {
    return {};
  }
  const params = search.split("&");
  const obj = {};
  return params.reduce((acc, param) => {
    const [name, value] = param.split("=");
    const arr = acc[name] || [];
    if (!acc[name]) {
      acc[name] = arr;
    }
    arr.push(value);
    return acc;
  }, obj);
};
var utmTags = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];
var getUtmTags = (url) => {
  const all = getQueryParams(url);
  return Object.keys(all).filter((key) => utmTags.indexOf(key) >= 0).reduce((acc, key) => {
    var _a;
    return __spreadProps(__spreadValues({}, acc), { [key]: (_a = all[key]) == null ? void 0 : _a[0] });
  }, {});
};
var sendEvent = (event2) => {
  if ("sendBeacon" in navigator) {
    navigator.sendBeacon(collector, JSON.stringify(event2));
  } else {
    fetch(collector, {
      method: "POST",
      body: JSON.stringify(event2),
      headers: { "Content-Type": "application/json" }
    }).catch(console.error);
  }
};
var LogBuffer = class extends Array {
  constructor(...args) {
    super(...args);
  }
  push(entry) {
    if (!collector) {
      console.warn("Our insights: No collector specified, no events will be pushed");
    }
    const length = super.push(entry);
    if (initiated) {
      const entries = this.splice(0);
      entries.forEach(sendEvent);
    }
    return length;
  }
  patch(op) {
    this.forEach(op);
  }
  flush(force) {
    if (initiated || force) {
      const entries = this.splice(0);
      entries.forEach(sendEvent);
    }
  }
};
var _buffer = new LogBuffer();
var getCommonData = () => {
  const session = getSession();
  const now = new Date().getTime();
  return __spreadProps(__spreadValues({}, getUtmTags(location.href)), {
    consenting,
    engaged: session.eng,
    language: navigator.language,
    sessionTime: now - session.ts,
    location: location.href,
    referrer: session.ref,
    reloads,
    screenW: screen.width,
    screenH: screen.height,
    sequence: session.seq,
    sid: session.id,
    title: document.title,
    uid,
    version: "0.0.5",
    viewportW: window.innerWidth,
    viewportH: window.innerHeight,
    z: new Date().getTime()
  });
};
var facilitateItems = (items) => {
  const keys = items.reduce((acc, item) => acc.concat(Object.keys(item)), []).filter((key, i, self) => self.indexOf(key) === i);
  return keys.reduce((acc, key) => {
    acc[key] = items.map((i) => i[key] || null);
    return acc;
  }, {});
};
var facilitateData = (data) => {
  if (!data) {
    return {};
  }
  const _data = __spreadValues({}, data);
  delete _data.items;
  return Object.keys(_data).reduce((acc, key) => {
    var _a;
    if (((_a = _data[key]) == null ? void 0 : _a.constructor) === Array) {
      acc[key] = facilitateItems(_data[key]);
    } else {
      acc[key] = _data[key];
    }
    return acc;
  }, {});
};
var enrich = (event2) => enrichers.reduce((acc, enricher) => __spreadValues(__spreadValues({}, acc), enricher(acc)), event2);
var eventInternal = (name, data) => {
  if (!collector) {
    return;
  }
  const commonData = getCommonData();
  const event2 = __spreadProps(__spreadValues(__spreadValues({}, commonData), facilitateData(data)), {
    event: name
  });
  const enrichedEvent = __spreadValues(__spreadValues({}, event2), enrich(event2));
  _buffer.push(enrichedEvent);
  return enrichedEvent;
};
var event = (name, data) => {
  if (!collector) {
    return;
  }
  if (name === PAGE_VIEW_EVENT_NAME) {
    return pageView(data == null ? void 0 : data.title);
  }
  if (FORBIDDEN_EVENTS.indexOf(name) >= 0) {
    console.warn(`${name} is not permitted as event name`);
    return;
  }
  return eventInternal(name, data);
};
var isEngaged = () => pageViewCount >= 2 && new Date().getTime() - getSession().ts >= 10 * 1e3;
var engagement = () => {
  const session = getSession();
  if (session.eng) {
    return;
  }
  session.eng = true;
  persistSession(session);
  eventInternal("engagement");
};
var pageEngagement = {
  event: () => {
    if (pageViewData) {
      const prev = __spreadValues({}, pageViewData);
      pageViewData = void 0;
      eventInternal("pageEngagement", {
        title: prev.title,
        location: prev.location,
        engagementTime: new Date().getTime() - prev.z
      });
    }
  },
  set: (pageViewEvent) => {
    if (pageViewEvent) {
      pageViewData = {
        z: pageViewEvent.z,
        title: pageViewEvent.title,
        location: pageViewEvent.location
      };
    }
  },
  reset: () => {
    pageViewData = {
      location: location.href,
      z: new Date().getTime(),
      title: document.title
    };
  }
};
var pageView = (title) => {
  pageViewCount++;
  if (isEngaged()) {
    engagement();
  }
  pageEngagement.event();
  const pageViewEvent = eventInternal(PAGE_VIEW_EVENT_NAME, { title });
  pageEngagement.set(pageViewEvent);
  return pageViewEvent;
};
var sessionStart = () => eventInternal("sessionStart");
var firstVisit = () => eventInternal("firstVisit");
var setConsent = (isConsenting) => {
  consenting = isConsenting;
  if (!consenting) {
    return;
  }
  if (memoryCookie) {
    const session = JSON.parse(memoryCookie);
    persistSession(session);
    memoryCookie = void 0;
  }
  if (uid) {
    persistUser(uid);
  }
  _buffer.flush();
};
var initBrowserEvents = () => {
  focus.onBlur(() => {
    pageEngagement.event();
  });
  focus.onFocus(() => {
    pageEngagement.reset();
  });
  const prev = window.onbeforeunload;
  window.onbeforeunload = (e) => {
    pageEngagement.event();
    _buffer.flush();
    if (prev) {
      prev.call(window, e);
    }
  };
};
var initEvents = () => {
  fetch(collector, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-consent": consenting.toString()
    }
  }).then((resp) => resp.json().then((data) => {
    uid = data.uid;
    _buffer.patch((ev) => ev.uid = data.uid);
    if (data.firstVisit) {
      firstVisit();
    }
    initiated = true;
    _buffer.flush();
  })).catch((err) => {
    initiated = false;
    console.error(err);
  });
};
var persistUser = (oiuid) => {
  fetch(collector, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-consent": consenting.toString(),
      "X-oiuid": oiuid
    }
  }).catch((err) => {
    initiated = false;
    console.error(err);
  });
};
var init = (options) => {
  var _a;
  try {
    if (!options.collector) {
      return;
    }
    consenting = !!options.consenting;
    collector = options.collector;
    enrichers = options.enrichers || [];
    (_a = options.events) == null ? void 0 : _a.forEach(({ name, data }) => event(name, data));
    initEvents();
    initBrowserEvents();
  } catch (err) {
    console.warn("Failed to initialize our insights", err);
  }
};
export {
  event,
  init,
  pageView,
  setConsent
};
